module.exports = __webpack_public_path__ + "static/AutoPolicyUpdatesDesktop-5168d480991f0415d46d20b8262cf700.webp";